import { App, ConfigProvider } from 'antd';
import { StyleProvider } from 'antd-style';
import { useContext, useLayoutEffect } from 'react';

// 全局静态message
export default ({ children }: { children: React.ReactNode }) => {
  const { locale, theme } = useContext(ConfigProvider.ConfigContext);

  useLayoutEffect(() => {
    ConfigProvider.config({
      holderRender: (children) => (
        <StyleProvider hashPriority="high">
          <ConfigProvider prefixCls="static" iconPrefixCls="icon" locale={locale} theme={theme}>
            <App message={{ maxCount: 1, duration: 10 }} notification={{ maxCount: 7 }}>
              {children}
            </App>
          </ConfigProvider>
        </StyleProvider>
      ),
    });
  }, [locale, theme]);

  return <>{children}</>; // 渲染子组件
};
